import React from 'react';
import ImprovementsListLayout from './components/ImprovementsListLayout';
import { AuditReportScoreData, SeoAuditImportantFix } from './types';
import AuditReportSeoScore from './AuditReportSeoScore';

type Props = {
    id: string;
    url: string;
    scoreData: AuditReportScoreData;
    createdAt: string;
    importantFixes: SeoAuditImportantFix[];
};

export default function AuditReportSummary({ id, url, scoreData, createdAt, importantFixes }: Props) {
    return (
        <div id={id}>
            <AuditReportSeoScore
                url={url}
                scoreData={scoreData}
                createdAt={createdAt}
            />
            <ImprovementsListLayout
                importantFixes={importantFixes}
                createdAt={createdAt}
            />
        </div>
    );
}
